(ns app.front.view.group.admin.integration.ecm
  (:require [app.domain.group.config.integration-model :as integration-model]
            [app.domain.group.integration-config-model :as integration-config-model]
            [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.integration.common :as iconf]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::stored-config
  :<- [::gas/group]
  (fn [group _]
    (some-> group
            :group/ecm-integration-config
            (select-keys integration-config-model/integration-config-keys)
            (p/update-if-contains :integration-config/package-pdf-template :db/id))))

(rf/reg-sub ::package-templates
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] _]
    (entities/find-entities ctx {:domain/authority-group group-id
                                 :entity/type            :entity.type/package-pdf-template})))

(defn package-pdf-editor
  [{:keys [tr editing?]} {:integration-config/keys [package-pdf-template]}]
  (let [templates         (<sub [::package-templates])
        selected-template (p/find-first templates {:db/id package-pdf-template})]
    [:div
     (if editing?
       [ui-select/select {:id           "package-template-select"
                          :light        true
                          :class-name   "full-width-select"
                          :values       templates
                          :val->str     :package-pdf-template/name
                          :value        selected-template
                          :required     true
                          :allow-empty? false
                          :label-text   (tr [:integration-config/package-pdf-template])
                          :on-change    #(>evt [::iconf/set-attr :integration-config/package-pdf-template (:db/id %)])}]
       [acommon/form-item
        tr
        :integration-config/package-pdf-template
        (:package-pdf-template/name selected-template)])]))

(defn workspace-attr-mapping-editor
  [{:keys [tr editing?]} {:integration-config/keys [service workspace-attr-mapping]}]
  (let [group       (<sub [::gas/group])
        permit-type (group-model/primary-permit-type group)]
    [:div.mt-4.border.border-gray-400.border-solid.rounded.p-4
     [:div.font-bold.mb-4 (tr [:integration-config/workspace-attr-mapping])]
     (when editing?
       [:div.mb-4 (tr [:integration-config/workspace-attr-guide]
                      [(tr [service])])])
     [ui-table/modern-responsive-table
      {:items   (some->> permit-type integration-model/ws-attrs-for-ecm-by-type)
       :id-func identity
       :cols    [[:integration-config/workspace-attr
                  (fn [k]
                    [:div.font-semibold (tr [k])])
                  {}]
                 [(tr [:integration-config/ecm-integration-field-code]
                      [(tr [service])])
                  (fn [k]
                    (let [v (get workspace-attr-mapping k)]
                      [:div.font-mono
                       (if editing?
                         [ui/text-input {:value     v
                                         :on-change #(let [new-val (futil/tval %)]
                                                       (rf/dispatch-sync
                                                         (if (str/blank? new-val)
                                                           [::iconf/dissoc-deep-attr
                                                            [:integration-config/workspace-attr-mapping k]]
                                                           [::iconf/set-deep-attr
                                                            [:integration-config/workspace-attr-mapping k]
                                                            new-val])))}]
                         v)]))
                  {}]]
       :tr      tr}]]))

(defn view
  "Sub-view for ECM config on the Integration config page."
  [{:keys [tr group]}]
  (let [group-id (:db/id group)]
    [iconf/config-editor-page
     (util/mmap {:integration-type           :integration-config.type/ecm
                 :stored-config-subscription [::stored-config]
                 :save-command               :group/save-ecm-integration
                 :attr-editors               {:integration-config/workspace-attr-mapping workspace-attr-mapping-editor
                                              :integration-config/package-pdf-template   package-pdf-editor}}
                tr group-id)]))

(defn group-config-editor
  "Editor component for group config tree, for setting the ECM container name."
  [{:keys [tr *group-config parent-config]}]
  (when (<sub [::gas/ecm-integration-enabled?])
    (let [gc-key    :group.config/ecm-integration-container-id
          parent-id (gc-key parent-config)
          this-id   (gc-key @*group-config "")
          config    (<sub [::stored-config])
          service   (:integration-config/service config)
          tr-key    (keyword (str "integration-config." (name service)) (name gc-key))]
      (cc/form-group
        {:legend-text (tr [:integration-config/ecm-integration-gc-title]
                          [(tr [service])])}

        (when parent-id
          [:div.flex.flex-wrap.items-center
           [:div.mr-2 (str (tr [:integration-config/inherited-from-parent]) ":")]
           [:div.bg-ui-blue-10.rounded.p-1.mr-2
            [:span.font-mono parent-id]]])

        [:div.w-64
         [ui/text-input {:label-text  (tr [tr-key])
                         :input-class "font-mono"
                         :value       this-id
                         :placeholder (or parent-id "")
                         :on-change   #(let [v (futil/tval %)]
                                         (if (str/blank? v)
                                           (swap! *group-config dissoc gc-key)
                                           (swap! *group-config assoc gc-key (futil/tval %))))}]]))))
